import {Box, Stack} from "@mui/material";
import NewFileDialog from "../../../components/dialog/NewFileDialog";
import {useState} from "react";
import {FileBase} from "../../../types/solicitation/solicitationFile";


interface CardDocumentationContentProps {
    clientId: number,
    onNewDoc?: (fileBase?: FileBase, file?: File, fileId?: number) => Promise<number>,
    fileType?: number,
    onReload?: () => void,
    size?: 'small' | 'medium' | 'large'
}


const CardDocumentationContent = ({clientId, onNewDoc, fileType, onReload, size = 'large'}: CardDocumentationContentProps) => {
    const [openNewFile, setOpenNewFile] = useState<boolean>(false)
    
    return (
        <Stack spacing={2}>
            <Box sx={{
                height: size === 'small' ? '100px' : '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                color: '#cccccc',
                borderColor: 'grey',
                borderRadius: '10px',
                borderStyle: 'dashed',
                borderWidth: '4px'
            }}
                 onClick={() => {setOpenNewFile(true)}}
            >
                <p>Haga click aquí para agregar archivos</p>
            </Box>
            {
                openNewFile &&
                <NewFileDialog open={openNewFile}
                               onClose={() => {setOpenNewFile(false)}}
                               clientId={clientId}
                               onNewFile={onNewDoc}
                               fileType={fileType}
                               onReload={onReload}
                />
            }
        </Stack>
    )
}


export default CardDocumentationContent